<template>
  <div class="transfers">
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells v-if="is_show_create_btn">
        <app-button @click.native="onShowCreatePopup('other')">Other transfer</app-button>
        <app-button @click.native="onShowFastTransfer('departure')" :disabled="!groupDetail.meeting_time && !groupDetail.starting_point">
          Departure transfer
        </app-button>
        <app-button @click.native="onShowFastTransfer('arrival')" :disabled="!groupDetail.meeting_time && !groupDetail.starting_point">
          Arrival transfer
        </app-button>
      </app-cells>
      <app-cells>
        <h2 class="title">Upcoming</h2>
      </app-cells>
      <template v-if="upcoming_transfers.length">
        <div v-for="transfer_item in upcoming_transfers" :key="`requested_${transfer_item.name}`" style="margin-bottom: 30px">
          <app-cells v-if="transfer_item.name">
            <h2 class="title">{{ transfer_item.name }}</h2>
            <div v-if="transfer_item.today" class="status-title" :style="{ 'backgroundColor': '#77b017' }">Today</div>
          </app-cells>
          <div v-for="(transfer, index) in transfer_item.items" :key="`waiting_${transfer.id}`">
            <transfers-blocks
                @onOpenEditPopup="onOpenEditPopup"
                @onCancelledTransfer="onCancelledTransfer"
                @onDeleteTransfer="onDeleteTransfer"
                :transfer="transfer"
                :count="index + 1"
                :is_show_arrange_button="false"
            />
          </div>
        </div>
      </template>
      <div v-else class="no-results">
        <img src="@/assets/img/schedule-plug-icon.svg" alt="">
        <div class="no-results__title">No Results</div>
        <div class="no-results__text">There’s no transfers yet</div>
      </div>
      <template v-if="archive_transfers.length">
        <app-cells>
          <h2 class="title">Archive</h2>
        </app-cells>
        <div v-for="transfer_item in archive_transfers" :key="`archive_${transfer_item.name}`">
          <app-cells v-if="transfer_item.name">
            <h2 class="title">{{ transfer_item.name }}</h2>
            <div v-if="transfer_item.today" class="status-title" :style="{ 'backgroundColor': '#77b017' }">Today</div>
          </app-cells>
          <div v-for="(transfer, index) in transfer_item.items" :key="`archive_${transfer.id}`">
            <transfers-blocks
                :transfer="transfer"
                :count="index + 1"
                :is_show_arrange_button="false"
            />
          </div>
        </div>
      </template>
    </template>
    <modal
        name="request-popup"
        :width="800"
        :height="'auto'"
        :scrollable="true"
        :clickToClose="false"
        class="modal-not-overflow"
        draggable=".popup__title"
        :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('request-popup')" class="popup__close" type="button"></button>
        <div class="popup__title">
          {{ `Request ${climbing_type} transfer` }}
        </div>
        <div class="popup__body">
          <form @submit.prevent="onCheckForm">
            <app-grid>
              <template #item-1>
                <app-form-group label="Name" label-for="cl_name" required>
                  <app-input
                      v-model="form.name"
                      placeholder="Name"
                      id="name"
                      name="cl_name"
                      :error="$v.form.name.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.name.$dirty && !$v.form.name.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Pick-up point" required>
                  <app-select
                    @input="onPickUpPointSelected(form.pick_up_point)"
                    @search="onLocationSearch"
                    v-model="form.pick_up_point"
                    :options="location_options"
                    :filterable="false"
                    :clearable="false"
                    placeholder="Select"
                    :error="$v.form.pick_up_point.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.pick_up_point.$dirty && !$v.form.pick_up_point.required">Required field</div>
                  </template>
                </app-form-group>
                <app-grid>
                  <template #item-1>
                    <app-form-group label="Pick-up date" required>
                      <app-date-picker
                        v-model="form.pick_up_date"
                        :clearable="false"
                        placeholder="Tour start"
                      />
                      <template #error>
                        <div v-if="$v.form.pick_up_date.$dirty && !$v.form.pick_up_date.required">Required field</div>
                        <div v-if="$v.form.pick_up_date.$dirty && !$v.form.pick_up_date.minValue">
                          Date cannot be less than the current date
                        </div>
                      </template>
                    </app-form-group>
                  </template>
                  <template #item-2>
                    <app-form-group label="Pick-up time" label-for="reported_time" required>
                      <app-input
                          v-model="form.pick_up_time"
                          v-mask="'99:99'"
                          placeholder="00:00"
                          autocomplete="off"
                          id="reported_time"
                          name="reported_time"
                          @paste.native.prevent
                          :error="$v.form.pick_up_time.$error"
                      />
                      <template #error>
                        <div v-if="$v.form.pick_up_time.$dirty && !$v.form.pick_up_time.required">Required field</div>
                        <div v-if="$v.form.pick_up_time.$dirty && !$v.form.pick_up_time.timeRegex">Wrong time</div>
                      </template>
                    </app-form-group>
                  </template>
                </app-grid>
                <draggable
                    :list="form.points"
                    v-bind="dragOptions"
                    handle=".sortable__handle"
                    class="transfer-sortable transfer-sortable--lite"
                >
                  <transition-group type="transition" :name="'flip-list'" tag="div">
                    <div v-for="(element, index) in form.points" :key="`points_${index}`" class="transfer-sortable__item">
                      <div class="transfer-sortable__row">
                        <app-form-group :label="`Destination ${index + 1}`" class="form-group--no-indent" required>
                          <app-select
                            @input="onLocationSelected(element.location, index)"
                            @search="onLocationSearch"
                            v-model="element.location"
                            :options="location_options"
                            :filterable="false"
                            :clearable="false"
                            placeholder="Select"
                            :error="$v.form.points.$each[index].location.$error"
                          />
                          <template #error>
                            <div v-if="$v.form.points.$each[index].location.$dirty && !$v.form.points.$each[index].location.required">Required field</div>
                          </template>
                        </app-form-group>
                        <button type="button" class="transfer-sortable__btn sortable__handle">
                          <img src="@/assets/img/sortable-arrow.svg" alt="Arrow">
                        </button>
                        <button
                            v-if="index !== 0"
                            @click="onRemoveDestination(index)"
                            class="transfer-sortable__close"
                            type="button"
                        >
                          <img src="@/assets/img/delete-transfer.svg" alt="Delete">
                        </button>
                      </div>
                    </div>
                  </transition-group>
                </draggable>
                <app-cells>
                  <app-button @click.native="onAddDestination" size="small">
                    <img src="@/assets/img/plus-icon.svg" alt="Add">
                    <span>Add destination</span>
                  </app-button>
                </app-cells>
              </template>
              <template #item-2>
                <app-form-group label="Crew" label-for="crew">
                  <app-input
                      v-model.number="form.other_pax"
                      placeholder="0"
                      id="crew"
                      name="crew"
                      type="number"
                  />
                </app-form-group>
                <app-form-group label="Clients">
                  <template #additional>
                    <button
                        v-show="clients_options.length !== form.clients.length"
                        @click="onAddAllClients"
                        type="button"
                        style="line-height: 0"
                    >
                      <img src="@/assets/img/add-all-icon.svg" alt="">
                    </button>
                    <button
                        v-show="form.clients.length"
                        @click="onRemoveAllClients"
                        type="button"
                        style="line-height: 0"
                    >
                      <img src="@/assets/img/clear-all-icon.svg" alt="">
                    </button>
                  </template>
                  <app-select
                    v-model="form.clients"
                    :options="clients_options"
                    label="full_name"
                    multiple
                    placeholder="Clients"
                  />
                </app-form-group>
              </template>
            </app-grid>
            <app-form-group label="Notes" label-for="notes">
              <app-textarea
                v-model="form.notes"
                id="notes"
                placeholder="Notes"
              />
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button type="submit" ref="submit">{{ is_create ? 'Create' : 'Save' }} request</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
        name="accept-modal"
        :width="400"
        :height="'auto'"
        :scrollable="true"
        :adaptive="true"
        :clickToClose="false"
        class="modal-not-overflow"
        draggable=".popup__title"
        :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('accept-modal')" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Change status
        </div>
        <div class="popup__body">
          <div class="popup__subt">Are you sure you want to cancelled this transfer?</div>
          <app-cells position="center" :indent="false">
            <app-button @click.native="$modal.hide('accept-modal')" theme="dark">Cancel</app-button>
            <app-button @click.native="cancelTransfer" ref="delete">Yes</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
    <modal
        name="accept-delete-modal"
        :width="400"
        :height="'auto'"
        :scrollable="true"
        :adaptive="true"
        :clickToClose="false"
        class="modal-not-overflow"
        draggable=".popup__title"
        :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('accept-delete-modal')" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Change status
        </div>
        <div class="popup__body">
          <div class="popup__subt">Are you sure you want to deleted this transfer?</div>
          <app-cells position="center" :indent="false">
            <app-button @click.native="$modal.hide('accept-delete-modal')" theme="dark">Delete</app-button>
            <app-button @click.native="deleteTransfer" ref="delete">Yes</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  deleteTransfer,
  getClientsLite,
  getGoogleSearch,
  getClimbingGroupTransfersDatesList,
  patchClimbingTransfer,
  patchTransfers,
  postLocation,
  postTransferClimbing,
} from '@/http'
import TransfersBlocks from '@/views/transfer/transfers/TransfersBlocks'
import { helpers, required } from 'vuelidate/lib/validators'
import debounce from 'lodash/debounce'
import draggable from 'vuedraggable'

const timeRegex = helpers.regex('timeRegex', /^([0-1][0-9]|2[0-3]):([0-5][0-9])?$/i)

export default {
  name: 'ClimbingGroupsDetailTransfers',
  components: { TransfersBlocks, draggable },
  props: {
    groupDetail: Object,
  },
  data() {
    return {
      is_loaded: false,
      form: { name: '', points: [{ location: null }], clients: [] },
      climbing_type: '',
      clients_options: [],
      location_options: [],
      upcoming_transfers: [],
      archive_transfers: [],
      is_create: true,
      current_transfer_id: null
    }
  },
  validations: {
    form: {
      name: { required },
      pick_up_point: { required },
      pick_up_date: {
        required,
        minValue(val) {
          return val ? new Date(val) >= new Date(new Date().setHours(0, 0, 0, 0)) : true
        }
      },
      pick_up_time: {
        required,
        timeRegex
      },
      points: {
        $each: {
          location: { required },
        }
      },
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: 'destination',
        disabled: false,
        ghostClass: 'ghost'
      }
    },
    is_show_create_btn() {
      return this.$store.state.userGroups.map(item => item.code).includes('operations_supervisor') ||
        this.$store.state.userGroups.map(item => item.code).includes('climbing_supervisor') ||
        this.$store.state.userGroups.map(item => item.code).includes('general_manager') ||
        this.$store.state.userGroups.map(item => item.code).includes('climbing_manager')
    }
  },
  created() {
    this.form.name = this.groupDetail.name
    this.fetchItems()
    getClientsLite({ climbing_group: this.$route.params.id })
      .then(res => { this.clients_options = res.data })
  },
  methods: {
    onShowFastTransfer(type) {
      this.climbing_type = type
      this.form.name = this.groupDetail.name
      if (type === 'departure') {
        this.form = {
          name: this.groupDetail.name,
          pick_up_point: this.groupDetail.starting_point,
          pick_up_date: this.groupDetail.tour_start,
          pick_up_time: this.groupDetail.meeting_time,
          points: [{ location: this.groupDetail.route.departure_location }],
          clients: this.clients_options
        }
        // this.form.pick_up_point = this.groupDetail.starting_point
        // this.form.pick_up_date = this.groupDetail.tour_start
        // this.form.pick_up_time = this.groupDetail.meeting_time
        // this.form.points[0].location = this.groupDetail.route.transfer_location
        // this.form.clients = this.groupDetail.clients
      } else if (type === 'arrival') {
        this.form = {
          name: this.groupDetail.name,
          pick_up_point: this.groupDetail.route.arrival_location,
          pick_up_date: this.groupDetail.tour_end,
          pick_up_time: '12:00',
          points: [{ location: this.groupDetail.starting_point }],
          clients: this.clients_options
        }
        // this.form.pick_up_point = this.groupDetail.route.transfer_location
        // this.form.pick_up_date = this.groupDetail.tour_end
        // this.form.pick_up_time = '12:00'
        // this.form.points[0].location = this.groupDetail.starting_point
        // this.form.clients = this.groupDetail.clients
      }
      // this.$v.form.$reset()
      this.is_create = true
      this.$modal.show('request-popup')
    },
    onCancelledTransfer(id) {
      this.current_transfer_id = id
      this.$modal.show('accept-modal')
    },
    cancelTransfer() {
      this.$refs.delete.preload = true
      patchTransfers(this.current_transfer_id, { status: 'cancelled' })
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Transfer cancelled',
          })
          this.fetchItems()
          this.$modal.hide('accept-modal')
        })
        .catch(() => { this.$refs.delete.preload = false })
    },
    onDeleteTransfer(id) {
      this.current_transfer_id = id
      this.$modal.show('accept-delete-modal')
    },
    deleteTransfer() {
      this.$refs.delete.preload = true
      deleteTransfer(this.current_transfer_id)
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Transfer deleted',
          })
          this.fetchItems()
          this.$emit('refreshTabCounts')
          this.$modal.hide('accept-delete-modal')
        })
        .catch(() => { this.$refs.delete.preload = false })
    },
    onShowCreatePopup(type) {
      this.climbing_type = type
      this.form = { name: this.groupDetail.name, points: [{ location: null }], clients: [] }
      this.$v.form.$reset()
      this.is_create = true
      this.$modal.show('request-popup')
    },
    onOpenEditPopup(transfer) {
      this.form = { ...transfer, points: [ ...transfer.points ] }
      this.$v.form.$reset()
      this.is_create = false
      this.$modal.show('request-popup')
    },
    onRemoveAllClients() {
      this.form.clients = []
    },
    onAddAllClients() {
      this.form.clients = this.clients_options
    },
    fetchItems() {
      Promise.all([
        getClimbingGroupTransfersDatesList({ group_by: 'pick_up_date', range_type: 'day', climbing_group: this.$route.params.id, category: 'upcoming' }),
        getClimbingGroupTransfersDatesList({ group_by: 'pick_up_date', range_type: 'day', climbing_group: this.$route.params.id, category: 'archive' })
      ])
        .then(res => {
          this.upcoming_transfers = res[0].data
          this.archive_transfers = res[1].data
          this.is_loaded = true
        })
    },
    onCheckForm() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit.preload = true
      if (this.is_create) {
        postTransferClimbing(this.normalizeForm())
          .then(() => {
            this.$modal.hide('request-popup')
            this.fetchItems()
            this.$emit('refreshTabCounts')
            this.$notify({
              type: 'success',
              title: 'Transfer requested',
            })
          })
          .catch(() => { this.$refs.submit.preload = false })
      } else {
        patchClimbingTransfer(this.form.id, this.normalizeForm())
          .then(() => {
            this.$modal.hide('request-popup')
            this.fetchItems()
            this.$emit('refreshTabCounts')
            this.$notify({
              type: 'success',
              title: 'Transfer saved',
            })
          })
          .catch(() => { this.$refs.submit.preload = false })
      }
    },
    normalizeForm() {
      const normalizedForm = {}

      normalizedForm.name = this.form.name
      normalizedForm.points = this.form.points.map((item, index) => ({ location: item.location.id, sort: index }))
      if (this.form.clients && this.form.clients.length) normalizedForm.clients = this.form.clients.map(item => item.id)
      normalizedForm.pick_up_point = this.form.pick_up_point.id
      normalizedForm.pick_up_date = this.form.pick_up_date
      normalizedForm.pick_up_time = this.form.pick_up_time
      normalizedForm.climbing_group = this.$route.params.id
      if (!this.form.other_pax) delete this.form.other_pax
      else normalizedForm.other_pax = this.form.other_pax
      normalizedForm.notes = this.form.notes
      if (this.is_create) normalizedForm.climbing_type = this.climbing_type
      return normalizedForm
    },
    onRemoveDestination(index) {
      this.form.points.splice(index, 1)
      this.$v.form.points.$touch()
    },
    onAddDestination() {
      this.form.points.push({ location: null })
    },
    onLocationSelected({ name, place_id }, index) {
      this.$refs.submit.preload = true
      postLocation({ name, place_id }).then(res => {
        this.form.points[index].location = res.data
        this.$refs.submit.preload = false
      })
    },
    onPickUpPointSelected({ name, place_id }) {
      this.$refs.submit.preload = true
      postLocation({ name, place_id }).then(res => {
        this.form.pick_up_point = res.data
        this.$refs.submit.preload = false
      })
    },
    onLocationSearch(search, loading) {
      loading(true)
      this.searchLocation(loading, search, this)
    },
    searchLocation: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.location_options = []
      } else {
        getGoogleSearch(search).then(response => {
          loading(false)
          vm.location_options = response.data
        })
      }
    }, 350),
  }
}
</script>

<style lang="sass" scoped>
.transfers
  position: relative
  min-height: 200px
</style>
